// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1MjUl","load":"Loader_load__UqRi3"};